import { useQuery } from 'react-query';

import { Insight, getInsight } from '@utils/backend-api/insights';

export const INSIGHTS_KEY = 'insights';

interface InsightArgs {
  relationshipSource: string;
  relationshipType: string;
  limit?: number;
}

export default function useInsight({
  relationshipSource,
  relationshipType,
  limit = 10,
}: InsightArgs) {
  const { data: insight, isLoading: isLoadingInsight } = useQuery<Insight>(
    [INSIGHTS_KEY, relationshipSource, relationshipType, limit],
    async () => await getInsight(relationshipSource, relationshipType, limit)
  );
  return { insight, isLoadingInsight };
}
